<div id="home-about" class="pb-4">
    <div class="container">
        <div class="card shadow border-0 p-4 rounded-4">
            <div class="row">
                <div class="col-12 col-md-4 mb-3 mb-md-0 text-center">
                    <img src="/assets/img/home-about/1.jpeg" class="img-fluid rounded-4 shadow" alt="">
                    <h5 class="fw-bold mt-3">Late Sh. Rakesh Aggarwal Ji</h5>
                    <h5 class="fw-bold">Founder & Visionary</h5>
                    <p class="inner-lead text-center">न त्वेवाहुं जातु नासं न त्वं नेमे जनाधिया: | <br>
                        न चैव न भविष्याम: सर्वे वयमत: परम् ||</p>
                </div>
                <div class="col-12 col-md-8 mb-3 mb-md-0">
                    <h2 class="home-title">Welcome to IIMT</h2>
                    <p class="inner-lead"><strong>Ideal Institute of Management and Technology</strong> was setup in 1999
                        under the aegis of New Millennium Education Society. The
                        society came into being with a clear objective to establish and run Institutions for
                        Professional, Technical and Management Education in accordance with the policies and the
                        regulations of the State Govt. and Central Govt. The word "New Millennium Education" aimed at by
                        the society, is in full tune with the requirements of New Millennium - "An education that
                        ensures a career for the individual, fulfils the need of the society and meets the demands of
                        the nation". From a very modest start, the institute has now acquired a commendable position as
                        premier Institute in imparting education for BBA, BCA, BA LL.B. (H), LL.M (Corp. Law) and LL.M
                        (IPR) programmes of Guru Gobind Singh Indraprastha University, Delhi</p>
                    <p class="inner-lead">The Institute is housed in an aesthetically designed campus surrounded by
                        greenery, in a prime location of East Delhi. The campus equipped with latest State-Of-The-Art
                        technology having CCTVs cameras to monitor Campus activities along with duly approved fire
                        safety measures. The campus is easily reachable having Karkardooma Metro Station and Preet Vihar
                        Metro Stations (Blue Line) at a distance of 1 km., Karkardooma Court Metro station at a distance
                        of 500 mts. only and Welcome Metro Station (Red Line) at a distance of 3 kms. The spacious well
                        designed building exhibits contemporary architectural beauty and makes it thoroughly enjoyable
                        place for students. The building is installed with complementary ramps and elevators for
                        comfortable access to differently-abled students. The entire campus is Wi-Fi enabled to provide
                        mobility to the users.</p>
                    <a href="http://www.ipu.ac.in/" target="_blank">University Overview <i
                            class="fa-regular fa-circle-up"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>